<script>
import RosterIndex from "./RosterIndex.vue";

export default {
  name: "RosterActualIndex",
  extends: RosterIndex,
};
</script>
